import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { MultiSelect } from '../../common/components/formControls';
import { loadWorkshopsBySearchTerm, fetchWorkshop } from './actions';
import moment from 'moment';
import MultiSelectListWithPaging from './MultiSelectListWithPaging'

class WorkshopsMultiSelect extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleSearchTermChange = this.handleSearchTermChange.bind(this);
		this.handleNextPageClick = this.handleNextPageClick.bind(this);

		this.state = {
			searchTerm: '',
			selectedIds: []
		};
	}

	componentDidMount() {
		this.searchWorkshops('');
	}

	searchWorkshops(searchTerm, nextPage = false) {
		const { pageNumber = 1, pageSize = 50 } = this.props.workshopsBySearchTerm[searchTerm] || { pageNumber: 1, pageSize: 50 };
		this.props.loadWorkshopsBySearchTerm({ sortKey: 'id', sortDirection: 'desc', pageNumber: pageNumber + (nextPage ? 1 : 0), pageSize, name: searchTerm });
	}

	handleSelectChange(workshops) {
		const selectedWorkshopIds = workshops ? workshops.filter(x => !!x && x.id).map(x => x.id) : [];
		this.setState({ selectedIds: selectedWorkshopIds });
	}

	handleSearchTermChange(searchTerm) {
		this.setState({ searchTerm });
		this.searchWorkshops(searchTerm);
	}

	handleNextPageClick() {
		this.searchWorkshops(this.state.searchTerm, true);
	}

	getFilteredData() {
		const workshopsPagination = this.props.workshopsBySearchTerm[this.state.searchTerm] || { ids: [], loading: false, pages: 0, pageNumber: 0 };
		const data = workshopsPagination.ids.map(id => this.props.workshops[id]);

		return { data, loading: workshopsPagination.loading, hasNextPage: workshopsPagination.pages > workshopsPagination.pageNumber };
	}

	renderListItem({ item }) {
		return <div>
			<div style={{ fontWeight: 'bold' }}>{item.name}</div>
			<div>{item.centerName}</div>
			<div>{`${moment(item.startDate).format('LL')} - ${moment(item.endDate).format('LL')}`}</div>
		</div>;
	}

	renderSelectedItem({ item }) {
		return <span>{item.name}</span>;
	}

	render() {
		const { name = 'workshopId', workshops, workshopsBySearchTerm, ...rest } = this.props;

		const { data, loading, hasNextPage } = this.getFilteredData();

		return <Field name={name} component={MultiSelect}
			options={data}
			valueField='id'
			textField='name'
			busy={loading}
			itemComponent={this.renderListItem}
			valueComponent={this.renderSelectedItem}
			onChange={this.handleSelectChange}
			onSearch={this.handleSearchTermChange}
			filter={false}
			listComponent={MultiSelectListWithPaging}
			listProps={{
				hasNextPage,
				onNextPage: this.handleNextPageClick
			}}
			{...rest}
		/>;
	}
}

const mapStateToProps = (state) => {
	const { pagination, entities: { workshops } } = state;

	return {
		workshops,
		workshopsBySearchTerm: pagination.workshopsBySearchTerm
	};
};

WorkshopsMultiSelect.propTypes = {
	name: PropTypes.string,
	onChange: PropTypes.func
};

export default connect(mapStateToProps, {
	loadWorkshopsBySearchTerm,
	fetchWorkshop
})(WorkshopsMultiSelect);